// extracted by mini-css-extract-plugin
module.exports = {"header":"Collapsor_header_k1H03"};